import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, Grid, ListSubheader, DialogContent, DialogActions, List, ListItem, ListItemIcon, ListItemText, Checkbox, TextField, FormControlLabel, Switch, Chip} from '@material-ui/core';
import AppBarModal from '../general/AppBarModal';
import { BtnFolder, BtnForm } from "../general/BotonesAccion";
import TareasTerminadas from '../general/TareasTerminadas';
import emma_w from '../../global/imagenes/emma_w.png';
import { obtenerEstadosProceso } from '../../global/js/funciones';
import { fetchEstadosSiguienteBienestar } from './bienestar_estudiantil/services/bienestarAdministrarService';
import { ESTADOS_BIENESTAR, COD_ESTADO_AGENDAMIENTO, COD_ESTADO_SOLICITADO, COD_ESTADO_SOL_REMISION, COD_ESTADO_ATENDIDO, COD_CRISIS } from './helper';
import BienestarFormAgendar from './bienestar_estudiantil/forms/BienestarFormAgendar';

const ESTADOS_INICIALES = [COD_ESTADO_SOLICITADO, COD_ESTADO_SOL_REMISION];

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        backgroundColor: theme.palette.background.paper,
    },
}));

function RenderEstados({ estados_siguiente, estado, cambiarSeleccion }) {
    const classes = useStyles();
    return (
        <List className={classes.root} subheader={
            <ListSubheader component="div" >
            Seleccione Estado
            </ListSubheader>
        }>
            {Array.isArray(estados_siguiente) && estados_siguiente.map(({ secundario }) => {
            let { codigo, nombre } = secundario || {};
            return (
                <ListItem key={codigo} role={undefined} dense button onClick={() => cambiarSeleccion(codigo)} >
                    <ListItemIcon>
                        <Checkbox edge="start" checked={estado === codigo} tabIndex={-1} disableRipple />
                    </ListItemIcon>
                    <ListItemText id={codigo} primary={nombre} />
                </ListItem>
            );
            })}
        </List>
    );
}

class BienestarGestionar extends Component {
    
    formRef = React.createRef();
    constructor(props){
        super(props);
        this.state = {
            cargando: true,
            titulo_res: 'Cargando..',
            estado: '',
            estados_siguiente: [],
            seleccion: 'gestion',
            observacion: '',
            profesionales: [],
            isAgendamiento: false,
            soloProfesional: false,
            errorObservacion: false,
            errorEstado: false,
            motivo: '',
            porcentaje: '',
            es_interna: false
        }
    }

    async componentDidMount() {
        let { id_estado_actual } = this.props;
        const estados_siguiente = await this.loadEstadosSiguiente(id_estado_actual);
        this.setState({ estado: '', estados_siguiente, cargando: false });
    }

    async componentDidUpdate(prevProps, prevState) {
        let { 
            modalGestionarBienestar, 
            modalObservacionBienestar, 
            id_estado_actual 
        } = this.props;

        if (!prevProps.modalGestionarBienestar && modalGestionarBienestar) {
            this.reiniciarEstado();
            const estados_siguiente = await this.loadEstadosSiguiente(id_estado_actual);
            this.setState({ estado: '', estados_siguiente, cargando: false });
        }

        if (prevProps.modalGestionarBienestar && !modalGestionarBienestar) {
            this.reiniciarEstado();
        }

        if (!prevProps.modalObservacionBienestar && modalObservacionBienestar) {
            this.reiniciarEstado();
            this.setState({
                cargando: false,
                titulo_res: 'Cargando..',
                estado: id_estado_actual
            });
        }

        if (prevProps.modalObservacionBienestar && !modalObservacionBienestar) {
            this.reiniciarEstado();
        }

        if (prevState.estado !== this.state.estado && Array.isArray(this.state.estados_siguiente)) {
            const estadoSeleccionado = this.state.estados_siguiente.find(
                est => est.secundario.codigo === this.state.estado
            );

            const codigoDestino = estadoSeleccionado?.secundario?.codigo;
            const soloProfesional = codigoDestino === COD_ESTADO_ATENDIDO
                && this.esCrisis()
                && !this.tieneProfesional();
            const isAgendamiento = Boolean(codigoDestino === COD_ESTADO_AGENDAMIENTO || soloProfesional);
            if (isAgendamiento !== this.state.isAgendamiento || soloProfesional !== this.state.soloProfesional) {
                this.setState({ isAgendamiento, soloProfesional });
            }
        }

    }

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    loadEstadosSiguiente = async (id_estado_actual) => {
        const id = id_estado_actual || this.props?.solicitud?.estado_actual?.id || null;
        if (!id) return [];
        const bienestarId = this.props?.id_proceso_actual || this.props?.solicitud?.id || null;
        if (bienestarId) return fetchEstadosSiguienteBienestar(bienestarId);

        try {
            const filtros = [
                { llave: 'principal', valor: id },
                { llave: 'secundario__generica', valor: ESTADOS_BIENESTAR }
            ];
            let estados = await obtenerEstadosProceso(id, filtros);
            if (!estados) estados = [];
            else if (Array.isArray(estados)) {
            } else if (estados.results && Array.isArray(estados.results)) {
                estados = estados.results;
            } else if (estados.data && Array.isArray(estados.data)) {
                estados = estados.data;
            } else if (estados.secundario && Array.isArray(estados.secundario)) {
                estados = estados.secundario;
            } else if (typeof estados === 'object') {
                const posibles = Object.keys(estados).filter(k => !isNaN(Number(k))).map(k => estados[k]);
                if (posibles.length) estados = posibles;
                else estados = [];
            }

            if (Array.isArray(estados)) {
                estados = estados.map(e => (e && e.secundario ? e : { secundario: e }));
            }
            return Array.isArray(estados) ? estados : [];
        } catch (err) {
            console.error('Error cargando estados siguientes', err);
            return [];
        }
    }


    esCrisis = () => this.props?.solicitud?.tipo_servicio?.codigo === COD_CRISIS;

    tieneProfesional = () => Boolean(
        this.props?.solicitud?.profesional_asignado
        || this.props?.solicitud?.detalle_agendamiento?.profesional_asignado
    );

    handleAgendarCita = async (datosCita) => {
        const pk = this.props.id_proceso_actual;
        const datosFinales = {
            ...datosCita,
            estado_anterior: this.props.solicitud.estado_actual.codigo,
            estado: this.state.estado,
            observacion: this.state.observacion,
            es_interna: this.state.es_interna
        };
        
        this.setState({
            cargando: true,
            titulo_res: this.state.soloProfesional ? 'Registrando atención...' : 'Agendando cita...',
        });

        try {
            await this.props.gestionarProceso(pk, datosFinales, () => {
            });
        } catch (error) {
            const mensajeError = error.response?.data?.titulo
                || (this.state.soloProfesional ? "Error al registrar la atención." : "Error al agendar la cita.");
            this.setState({ 
                titulo_res: `ERROR: ${mensajeError}`, 
                cargando: false 
            });
        }
    };

    reiniciarEstado() {
        this.setState({
        cargando: true,
        titulo_res: "Cargando..",
        estado: "",
        observacion: "",
        motivo: "",
        estados_siguiente: [],
        seleccion: "gestion",
        porcentaje: "",
        isAgendamiento: false,
        soloProfesional: false,
        es_interna: false,
        errorObservacion: false,
        errorEstado: false,
        });
    }


    onSubmit = async (e) => {
        e.preventDefault();

        if (this.props.modalObservacionBienestar) {

            if (!this.state.observacion || this.state.observacion.trim() === "") {
                this.setState({ errorObservacion: true });
                return;
            }
            this.setState({ cargando: true, titulo_res: "Enviando.." });
            const data = {
                bienestar: this.props.id_proceso_actual,
                texto: this.state.observacion,
                estado_asociado: this.props.id_estado_actual,
                es_interna: this.state.es_interna
            };
            this.props.crearObservacion(
                this.props.id_proceso_actual,
                data,
                () => this.setState({ cargando: false, titulo_res: "Cargando.." })
            );
            return;
        }

        if (!Array.isArray(this.state.estados_siguiente)) {
            console.error("estados_siguiente no es un array", this.state.estados_siguiente);
            return;
        }

        const estadoSeleccionado = this.state.estados_siguiente.find(
            est => est.secundario.codigo === this.state.estado
        );

        const estadoActualEsSolicitado =
            ESTADOS_INICIALES.includes(this.props.solicitud.estado_actual.codigo);
        const faltaObservacion =
            estadoActualEsSolicitado &&
            (!this.state.observacion || this.state.observacion.trim() === "");

        if (this.state.isAgendamiento) {
            if (faltaObservacion) {
                this.setState({ errorObservacion: true });
                return;
            }
            if (this.formRef.current) {
                this.formRef.current.requestSubmit();
            }
            return;
        }

        if (!this.state.estado) {
            this.setState({ errorEstado: true });
            return;
        }

        if (faltaObservacion) {
            this.setState({ errorObservacion: true });
            return;
        }

        this.setState({ cargando: true, errorObservacion: false, titulo_res: "Enviando.." });

        const dataGestion = {
            estado: this.state.estado,
            observacion: this.state.observacion,
            estado_anterior: this.props.solicitud.estado_actual.codigo,
            es_interna: this.state.es_interna
        };

        this.props.gestionarProceso(
            this.props.id_proceso_actual,
            dataGestion,
            () => this.setState({ cargando: false, titulo_res: "Cargando.." })
        );
    };

    pintarEstados(){
        let { estado, estados_siguiente, errorEstado  } = this.state;
        return (
            <Grid container >
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                {errorEstado && (
                    <span style={{ color: '#f44336', fontSize: '0.75rem' }}>
                        Debe seleccionar un estado para continuar.
                    </span>
                )}
                <RenderEstados cambiarSeleccion={(estado) => this.setState({ estado, errorEstado: false })} estado={estado} estados_siguiente={estados_siguiente} />
                </Grid>
            </Grid >
        )
    }

    pintar() {
        let { seleccion, isAgendamiento, soloProfesional, profesionales } = this.state;
        if (isAgendamiento) {
            return (
                <>
                    {/* Pedir solo el profesional no reemplaza el modal: se suma a los estados. */}
                    {soloProfesional && seleccion === 'gestion' && this.pintarEstados()}
                    <BienestarFormAgendar
                        ref={this.formRef}
                        onFinish={this.handleAgendarCita}
                        soloProfesional={soloProfesional}
                        profesionales={profesionales}
                        profesionalAsignado={
                            this.props?.solicitud?.profesional_asignado
                            || this.props?.solicitud?.detalle_agendamiento?.profesional_asignado
                            || null
                        }
                    />
                </>
            );
        }
        return (<div>
            {seleccion === 'gestion' && this.pintarEstados()}
        </div>)
    }

    render() {
            let { modalGestionarBienestar, mostrarModalGestionarBienestar, modalObservacionBienestar, mostrarModalObservacionBienestar, onClickDocumentosExtras, solicitud } = this.props;
            let { cargando, titulo_res, isAgendamiento, soloProfesional, estados_siguiente, es_interna, observacion, errorObservacion } = this.state;
            return (
                <>
                {modalGestionarBienestar && (
                <Dialog
                    fullWidth={true}
                    maxWidth="sm"
                    open={modalGestionarBienestar}
                    onClose={() => mostrarModalGestionarBienestar(false)}
                    aria-labelledby="bienestar-gestionar-title"
                >
                    <AppBarModal
                        titulo={"¿ Gestionar Bienestar ?"}
                        mostrarModal={mostrarModalGestionarBienestar}
                        titulo_accion=""
                        accion=""
                    />
                    <DialogContent style={{ padding: '1' }} className="scroll">
                        {cargando ? (
                            <TareasTerminadas 
                                mensaje={titulo_res} 
                                marginTop='7%' 
                                imagen={emma_w} 
                                widthImg="7%" 
                            /> 
                        ) : (
                                <div>
                                    {this.pintar()}
                                    {(!isAgendamiento || soloProfesional) &&
                                        estados_siguiente.length > 0 &&
                                        ESTADOS_INICIALES.includes(estados_siguiente[0].principal.codigo) && (
                                            <>
                                                <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                                                    <FormControlLabel
                                                        control={<Switch checked={es_interna} onChange={(e) => this.setState({ es_interna: e.target.checked })} color="primary" />}
                                                        label={es_interna ? "Observación Interna (solo administradores)" : "Observación Externa"}
                                                    />
                                                </div>
                                                <TextField 
                                                label="Observación" 
                                                name="observacion"
                                                value={observacion}
                                                onChange={this.handleInputChange}
                                                multiline
                                                rows={3}
                                                fullWidth
                                                variant="outlined" 
                                                error={errorObservacion}
                                                helperText={errorObservacion ? "Este campo es obligatorio." : ""}
                                                />
                                            </>
                                    )}
                                </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <BtnForm texto="CERRAR" callback={() => mostrarModalGestionarBienestar(false)} />
                        {!cargando && <BtnForm texto="ACEPTAR" callback={this.onSubmit} />}
                    </DialogActions>
                </Dialog>
                )}

                {modalObservacionBienestar && (
                <Dialog
                    fullWidth={true}
                    maxWidth="sm"
                    open={modalObservacionBienestar}
                    onClose={() => mostrarModalObservacionBienestar(false)}
                    aria-labelledby="bienestar-observacion-title"
                >
                    <AppBarModal
                        titulo={"Nueva Observación"}
                        mostrarModal={mostrarModalObservacionBienestar}
                        titulo_accion=""
                        accion=""
                    />
                    <DialogContent style={{ padding: '1' }} className="scroll">
                        {cargando ? (
                            <TareasTerminadas 
                                mensaje={titulo_res} 
                                marginTop='7%' 
                                imagen={emma_w} 
                                widthImg="7%" 
                            /> 
                        ) : (
                            <div style={{ marginTop: '1rem' }}>
                                <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                                    <FormControlLabel
                                        control={<Switch checked={es_interna} onChange={(e) => this.setState({ es_interna: e.target.checked })} color="primary" />}
                                        label={es_interna ? "Observación Interna (solo administradores)" : "Observación Externa"}
                                    />
                                    <BtnFolder callback={() => onClickDocumentosExtras(solicitud)} color='#f8e962ff' texto='Documentos Extras' />
                                </div>   
                                <TextField 
                                    label="Observación" 
                                    name="observacion"
                                    value={observacion}
                                    onChange={this.handleInputChange}
                                    multiline
                                    rows={3}
                                    fullWidth
                                    variant="outlined" 
                                    error={errorObservacion}
                                    helperText={errorObservacion ? "El campo Observación es obligatorio." : ""}
                                /> 
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <BtnForm texto="CERRAR" callback={() => mostrarModalObservacionBienestar(false)} />
                        {!cargando && <BtnForm texto="ACEPTAR" callback={this.onSubmit} />}
                    </DialogActions>
                </Dialog>
                )
                }
            </>
            )
        }
}

export default BienestarGestionar;
